/* @flow */

import { em } from 'polished';

import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    paddingTop: 90,
  },
  action: {
    marginTop: em(4, baseFontSize),
  },
};
